// Связь основного интерфейса с service worker (рендерит null, монтируется только после входа):
// - push пришёл — обновить счётчик непрочитанных;
// - клик по push, а окно не под контролем SW — перейти по ссылке здесь;
// - при старте и при смене подписки браузером — отправить актуальную подписку на сервер.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { refreshUnreadCount } from '../../hooks/useUnreadCount';
import { pushAvailableHere, syncPushSubscription } from '../../services/pushService';

export default function PushBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!pushAvailableHere() || !('serviceWorker' in navigator)) return undefined;

    syncPushSubscription();

    const onMessage = (event) => {
      const { type, url } = event.data || {};
      if (type === 'push-received') {
        refreshUnreadCount();
      } else if (type === 'open-url' && url) {
        const target = new URL(url, window.location.origin);
        if (target.origin === window.location.origin) navigate(`${target.pathname}${target.search}`);
      } else if (type === 'push-subscription-changed') {
        syncPushSubscription();
      }
    };
    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, [navigate]);

  return null;
}
